import { render, staticRenderFns } from "./DataAccessNew.vue?vue&type=template&id=3a82b0f4"
import script from "./DataAccessNew.vue?vue&type=script&lang=js"
export * from "./DataAccessNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports